import { STATUS_TYPES } from '_atoms/Status';

export const getStatusType = (status?: string) => {
  switch (status) {
    case 'Rejected':
    case 'Declined':
    case 'Job not started':
    case 'Fired':
      return STATUS_TYPES.RED;
    case 'Attend interview':
    case 'Provide feedback':
      return STATUS_TYPES.YELLOW;
    case 'Waiting for resolution':
    case 'Pending approval':
      return STATUS_TYPES.BLUE;
    case 'Hired':
      return STATUS_TYPES.GREEN;
    default:
      return STATUS_TYPES.GRAY;
  }
};
